import React from 'react';
import classNames from 'classnames';
import Styles from './table-body.less';
import Text from 'text/index';

const baseClass = Styles.tbody;

module.exports = React.createClass({
    displayName: 'TableBody',
    propTypes: {
        className: React.PropTypes.string
    },
    getChildren() {
        if(this.props.children.length) {
            return React.Children.toArray(this.props.children)
              .filter(React.isValidElement)
              .filter(child => child.type.displayName == 'TableRow');
        } else {
            return (<Text className={Styles.empty} tkey="Library.Items:NoItems" />)
        }
    },
    getClass() {
        return classNames(baseClass, this.props.className);
    },
    render: require('./table-body.rt')
});



/** WEBPACK FOOTER **
 ** ./src/table/table-body/table-body.js
 **/